import Vue from 'vue'
import App from './App.vue'
import router from '@/router/index'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Vant from 'vant';
import 'vant/lib/index.css';
import Bridge from '@/config/bridge.js'
import moment from "moment";
import myDirective from '@/utils/myDirective';
import carPlateKeyboard from 'car-plate-keyboard'
import 'car-plate-keyboard/lib/carPlateKeyboard.css'

Vue.use(carPlateKeyboard)
Vue.use(ElementUI);
Vue.use(Vant);
Vue.prototype.$bridge = Bridge
router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next()
})
Vue.prototype.$moment = moment;
Vue.config.productionTip = false

Vue.directive("input-limit", {
    bind(el, binding) {
        var wins_0 = /[^\d]/g //整数判断
        var wins_1 = /[^\d^\.]/g //小数判断
        var flag = true;
        var points = 0;
        var lengths = 0
        var remainder = 0
        var no_int = 0
        const target = el instanceof HTMLInputElement ? el : el.querySelector("input");
        target.addEventListener("compositionstart", e => {
            flag = false;
        });
        target.addEventListener("compositionend", e => {
            flag = true;
        });
        target.addEventListener("input", e => {
            setTimeout(function () {
                if (flag) {
                    if (binding.value == 0) {
                        if (wins_0.test(e.target.value)) {
                            e.target.value = e.target.value.replace(wins_0, "");
                            e.target.dispatchEvent(new Event("input")) //手动更新v-model值
                        }
                    }
                    if (binding.value == 1) {
                        if (wins_0.test(e.target.value.toString().replace(/\d+\.(\d*)/, '$1'))) {
                            remainder = true
                        }
                        if ((e.target.value.split('.')).length - 1 > 1) {
                            points = true
                        }
                        if (e.target.value.toString().split(".")[1] != undefined) {
                            if (e.target.value.toString().split(".")[1].length > 1) {
                                lengths = true
                            }
                        }
                        if (e.target.value.toString().indexOf(".") != -1) {
                            no_int = false
                        } else {
                            no_int = true
                        }
                        if (wins_1.test(e.target.value) || lengths || points || remainder) {
                            if (!no_int) {
                                e.target.value = e.target.value.replace(wins_1, "").replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').substring(0, e.target.value.indexOf(".") + 2)
                            } else {
                                e.target.value = e.target.value.replace(wins_0, "")
                            }
                            e.target.dispatchEvent(new Event("input"))
                        }
                    }


                    if (binding.value == 2) {
                        if (wins_0.test(e.target.value.toString().replace(/\d+\.(\d*)/, '$1'))) {
                            remainder = true
                        }
                        if ((e.target.value.split('.')).length - 1 > 1) {
                            points = true
                        }
                        if (e.target.value.toString().split(".")[1] != undefined) {
                            if (e.target.value.toString().split(".")[1].length > 2) {
                                lengths = true
                            }
                        }
                        if (e.target.value.toString().indexOf(".") != -1) {
                            no_int = false
                        } else {
                            no_int = true
                        }
                        if (wins_1.test(e.target.value) || lengths || points || remainder) {
                            if (!no_int) {
                                e.target.value = e.target.value.replace(wins_1, "").replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').substring(0, e.target.value.indexOf(".") + 3)
                            } else {
                                e.target.value = e.target.value.replace(wins_0, "")
                            }
                            e.target.dispatchEvent(new Event("input"))
                        }
                    }
                }
            }, 0)
        })
    }
})
Vue.prototype.$scrollTo = (x = 0, y = 0, type = 'smooth') => {
    window.scrollTo({
        top: x,
        left: y,
        behavior: type // 滚动行为：smooth平滑滚动，instant瞬间滚动，默认值auto，等同于instant
    })
}
Vue.config.ignoredElements = ['wx-open-launch-weapp']
Vue.use(myDirective);
new Vue({
    router,
    render: h => h(App)
}).$mount('#app')
